export default "__VITE_ASSET__D0M2JWA3__"